import React from 'react';
import Avatar from '@atlaskit/avatar';
import { AvatarWrapper } from './styled';
export var AvatarSkeleton = function AvatarSkeleton() {
  return /*#__PURE__*/React.createElement(AvatarWrapper, null, /*#__PURE__*/React.createElement(Avatar, {
    name: "",
    appearance: "circle",
    src: "",
    size: "large"
  }));
};